export const useNavigateToHome = () => {
  const router = useRouter()
  const { permissions } = useAuth()

  return {
    navigateToHome: () => {
      if (
        permissions.value.includes("view_platform_overview")
      ) {
        router.push({ name: "dashboard" })
        return
      }

      router.push({ name: "merchantIndex" })
    },
  }
}
